/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Secret_WarningInputs */



/**
* | output |
* | --- |
* | "Save this client secret now. It will not be shown again." |
*
* @param {Developer_Secret_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_secret_warning = /** @type {((inputs?: Developer_Secret_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Secret_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrez ce secret client maintenant. Il ne sera plus affiché.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guarde este secreto de cliente ahora. No se mostrará de nuevo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Salve este client secret agora. Ele não será mostrado novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva questo client secret ora. Non verrà mostrato nuovamente.")
	return /** @type {LocalizedString} */ ("Save this client secret now. It will not be shown again.")
});